<div class="plor-services-area-without-color pt-100 pb-70">
    <div class="container">
        <div class="section-title with-gradient-color">
            <h2>{{title}}</h2>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6">
                <div class="plor-services-box with-border wow animate__animated animate__fadeInUp" data-wow-delay="100ms" data-wow-duration="1000ms">
                    <h3>{{questions1}}</h3>
                    <p>{{answers1}}</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="plor-services-box with-border wow animate__animated animate__fadeInUp" data-wow-delay="200ms" data-wow-duration="1000ms">
                    <h3>{{questions2}}</h3>
                    <p>{{answers2}}</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="plor-services-box with-border wow animate__animated animate__fadeInUp" data-wow-delay="300ms" data-wow-duration="1000ms">
                    <h3>{{questions3}}</h3>
                    <p>{{answers3}}</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="plor-services-box with-border wow animate__animated animate__fadeInUp" data-wow-delay="400ms" data-wow-duration="1000ms">
                    <h3>{{questions4}}</h3>
                    <p>{{answers4}}</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="plor-services-box with-border wow animate__animated animate__fadeInUp" data-wow-delay="500ms" data-wow-duration="1000ms">
                    <h3>{{questions5}}</h3>
                    <p>{{answers5}}</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="plor-services-box with-border wow animate__animated animate__fadeInUp" data-wow-delay="600ms" data-wow-duration="1000ms">
                    <h3>{{questions6}}</h3>
                    <p>{{answers6}}</p>
                </div>
            </div>
        </div>
    </div>
</div>